/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
}

export const getters = {}

export const mutations = {
  SET_SERVICES(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
  },
  SET_SERVICE(state, objects) {
    state.currentService = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getServiceById({ commit }, { id } = {}) {
    try {
      await graphqlClient
        .query({
          query: gql`
            query ServiceById($ServiceId: ID!) {
              serviceById(id: $ServiceId) {
                id
                active
                service_title
                description
                client_id {
                  id
                  client_name
                }
                vehicle {
                  number_plate
                }
                service_type_id {
                  id
                  name
                }
                is_recurring
                schedule_string
                order_number
                email
                waste_type {
                  id
                  name
                }
                site {
                  trading_name
                  address
                  suburb
                  postcode
                  phone
                  mobile
                  contact_name
                  id
                }
                created_at
                updated_at
                deleted_at
                collections {
                  id
                }
                service_bins {
                  id
                  bin_id
                  price
                  weekly_maintenance_fee
                  issue_date
                  bin_identifier
                  bin {
                    id
                    description
                    capacity
                    price
                  }
                  charge_per_tonne
                  charge_per_litre
                  castors
                  padlocks
                  weight_allowed
                  extra_price
                }
              }
            }
          `,
          variables: { ServiceId: id },
        })
        .then(response => {
          commit('SET_SERVICE', response.data.serviceById)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getServiceByClientId({ commit }, { id } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query ServiceByClientId($cid: ID!) {
              serviceByClientId(client_id: $cid) {
                id
                active
                service_title
                description
                client_id {
                  id
                  client_name
                }
                service_type_id {
                  id
                  name
                }
                waste_type {
                  id
                  name
                }
                is_recurring
                schedule_string
                order_number
                email
                site {
                  trading_name
                  address
                  suburb
                  postcode
                  phone
                  mobile
                  contact_name
                  id
                }
                created_at
                updated_at
                deleted_at
                collections {
                  id
                }
                service_bins {
                  id
                  bin_id
                  price
                  weekly_maintenance_fee
                  bin {
                    description
                    capacity
                    price
                    name
                    id
                  }
                  castors
                  padlocks
                  weight_allowed
                  extra_price
                }
              }
            }
          `,
          variables: { cid: id },
        })
        .then(response => {
          // // console.log(response)
          commit('SET_SERVICES', response.data.serviceByClientId)
          return response.data.serviceByClientId
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  
  async getServices({ commit }) {
    const gql = require('graphql-tag')
    try {
      return await graphqlClient
        .query({
          query: gql`
            query {
              services {
                id
                active
                service_title
                description
                client_id {
                  id
                }
                service_type_id {
                  id
                  name
                }
                waste_type {
                  id
                  name
                }
                is_recurring
                schedule_string
                order_number
                email
                site {
                  trading_name
                  address
                  suburb
                  postcode
                  phone
                  mobile
                  contact_name
                  id
                }
                created_at
                updated_at
                deleted_at
                collections {
                  id
                }
                service_bins {
                  bin_id
                  price
                  weekly_maintenance_fee
                  bin {
                    description
                    capacity
                    price
                  }
                  castors
                  padlocks
                  weight_allowed
                  extra_price
                }
              }
            }
          `,
        })
        .then(response => {
          // console.log(response)
          commit('SET_SERVICES', response.data.services)
          return response.data.services
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createService(
    { commit, dispatch },
    {
      vehicle_id,
      service_title,
      description,
      is_recurring,
      schedule_string,
      client_id,
      created_by,
      service_type_id,
      site_id,
      time_windows,
      service_agreement_id,
      waste_type_id,
    } = {}
  ) {
    try {
      // let that = this
      // console.log(vehicle_id)
      const response = await graphqlClient.mutate({
        mutation: gql`
          mutation CreateService(
            $vehicleId: ID
            $title: String!
            $description: String
            $is_recurring: Boolean
            $schedule_string: String
            $client_id: Int!
            $service_type_id: Int
            $site_id: ID!
            $time_windows: [[ID]]
            $Agreement: ID
            $Waste: Int
          ) {
            createService(
              service: {
                service_title: $title
                service_type_id: $service_type_id
                client_id: $client_id
                site_id: $site_id
                description: $description
                is_recurring: $is_recurring
                schedule_string: $schedule_string
                time_windows: $time_windows
                service_agreement_id: $Agreement
                waste_type_id: $Waste
                vehicle_id: $vehicleId
              }
            ) {
              id
              service_title
            }
          }
        `,
        variables: {
          title: service_title,
          description: description,
          is_recurring: is_recurring,
          schedule_string: schedule_string,
          client_id: client_id,
          service_type_id: service_type_id,
          site_id: site_id,
          time_windows: time_windows,
          Agreement: service_agreement_id,
          Waste: waste_type_id,
          vehicleId: vehicle_id,
        },
      })
      return response
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async updateService(
    { commit },
    {
      vehicle_id,
      id,
      active,
      service_title,
      description,
      is_recurring,
      schedule_string,
      order_number,
      client_id,
      created_by,
      service_type_id,
      site_id,
      time_windows,
      service_agreement_id,
      waste_type_id,
    } = {}
  ) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation updateService(
              $vehicleId: ID
              $Id: Int!
              $Active: Boolean
              $title: String
              $description: String
              $is_recurring: Boolean
              $schedule_string: String
              $order_number: String
              $client_id: Int
              $service_type_id: Int
              $site_id: ID
              $time_windows: [[ID]]
              $Agreement: ID
              $Waste: Int
            ) {
              updateService(
                id: $Id
                service: {
                  service_title: $title
                  active: $Active
                  service_type_id: $service_type_id
                  client_id: $client_id
                  site_id: $site_id
                  description: $description
                  is_recurring: $is_recurring
                  schedule_string: $schedule_string
                  order_number: $order_number
                  time_windows: $time_windows
                  service_agreement_id: $Agreement
                  waste_type_id: $Waste
                  vehicle_id: $vehicleId
                }
              ) {
                id
                service_title
              }
            }
          `,
          variables: {
            Id: id,
            Active: active,
            title: service_title,
            description: description,
            is_recurring: is_recurring,
            schedule_string: schedule_string,
            order_number: order_number,
            client_id: client_id,
            service_type_id: service_type_id,
            site_id: site_id,
            time_windows: time_windows,
            Agreement: service_agreement_id,
            Waste: waste_type_id,
            vehicleId: vehicle_id,
          },
        })
        .then(response => {
          // console.log(response)
          commit('SET_SERVICES', response.data.updateService)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateServiceSchedule({ commit }, { id, schedule_string } = {}) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation updateService($Id: Int!, $schedule_string: String) {
              updateService(
                id: $Id
                service: { schedule_string: $schedule_string }
              ) {
                id
                service_title
              }
            }
          `,
          variables: { Id: id, schedule_string: schedule_string },
        })
        .then(response => {
          // console.log(response)
          commit('SET_SERVICES', response.data.updateService)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async deleteService({ commit }, { id } = {}) {
    try {
      // let that = this
      const response = await graphqlClient.mutate({
        mutation: gql`
          mutation DeleteService($Id: Int!) {
            deleteService(id: $Id) {
              id
            }
          }
        `,
        variables: { Id: id },
      })
      commit('SET_SERVICES', response.data.deleteService)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
}
